import React from 'react';
import { LogOut, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AdditionalOptionsProps {
  startNewEvaluation: () => void;
  session: any;
  handleLogout: () => void;
}

const AdditionalOptions: React.FC<AdditionalOptionsProps> = ({ 
  startNewEvaluation, 
  session, 
  handleLogout 
}) => {
  const { t } = useTranslation();

  return (
    <div className="card">
      <h4 className="font-medium text-gray-800 mb-2">{t('profile.additionalOptions.title')}</h4>
      
      <div className="space-y-2">
        <button 
          onClick={startNewEvaluation}
          className="flex items-center text-gray-700 hover:text-gray-900 w-full text-left py-2"
        >
          <RefreshCw className="w-5 h-5 mr-2" />
          <span>{t('profile.additionalOptions.startNewEvaluation')}</span>
        </button>
        
        {session && (
          <button 
            onClick={handleLogout}
            className="flex items-center text-gray-700 hover:text-gray-900 w-full text-left py-2"
          >
            <LogOut className="w-5 h-5 mr-2" />
            <span>{t('profile.additionalOptions.signOut')}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default AdditionalOptions;
